/**
 * Default Question Title for the auto-generated "Other" text-input: "<parent Question Title or label> - Other", else
 * "Other".
 */
export function defaultOtherInputQuestionTitle(parentQuestionTitle?: unknown, parentLabel?: unknown): string {
  const pick = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');
  const base = pick(parentQuestionTitle) || pick(parentLabel);
  return base ? `${base} - Other` : 'Other';
}
